import { PhoneAuthPage } from '@/components/auth/PhoneAuthPage';

const Register = () => <PhoneAuthPage variant="register" />;

export default Register;
